<template>
  <v-app id="forgot">
    <v-main class="background-login">
      <v-container fluid fill-height>
        <v-layout justify-center align-center>
          <v-flex xs12 sm12 md8>
            <v-layout wrap>
              <v-flex xs12 sm12 md6>
                <logo />
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-form @submit.prevent="submit">
                  <v-card color="primary" elevation="5" dark>
                    <v-card-title class="headline pl-5">¿Olvidaste tu contraseña?</v-card-title>
                    <v-card-text>
                      <p class="pl-1">Ingresa tu usuario y te enviaremos un correo con las instrucciones para reestablecer tu contraseña</p>
                      <v-text-field
                        v-model="username"
                        :disabled="loading"
                        prepend-icon="mdi-account"
                        required
                        autocomplete="off"
                        label="Usuario"
                        @input="$v.username.$touch()"
                        @blur="$v.username.$touch()"
                      >
                      </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn text :disabled="loading" @click="back()">Volver</v-btn>
                      <v-btn type="submit" text :loading="loading">Enviar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
                <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
                  {{ errorList[codeError] }}
                </v-snackbar>
                <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
                  {{ msgSuccess }}
                </v-snackbar>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
    <main-footer />
  </v-app>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import services from "@/utils/services";
import logo from "@/components/Logo";
import mainFooter from "@/components/Footer";
import errorList from "@/utils/errorsList";

export default {
  name: "forgot",
  components: { logo, mainFooter },
  mixins: [validationMixin],
  validations: {
    username: {
      required,
      maxLength: maxLength(50),
    },
  },
  data: () => ({
    loading: false,
    error: false,
    msgError: "",
    success: false,
    msgSuccess: "",
    username: "",
    errorList,
  }),
  computed: {
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.required && errors.push("El campo es obligatorio");
      !this.$v.username.maxLength && errors.push("El campo excede la longitud máxima");
      return errors;
    },
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.username = "";
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.recovery();
      } else {
        this.error = true;
        this.msgError = "El usuario es incorrecto";
      }
    },
    back() {
      this.$router.push("/login");
    },
    recovery() {
      this.loading = true;
      setTimeout(() => {
        this.axios
          .post(services.routes.recovery, { username: this.username })
          .then((response) => {
            let res = response.data;
            if (res.correcto) {
              this.clear();
              this.success = true;
              this.msgSuccess = res.mensaje;
            } else {
              this.error = true;
              this.msgError = res.mensaje;
            }
          })
          .catch(() => {
            this.error = true;
            this.codeError = error.response.data.code;
          })
          .finally(() => {
            this.loading = false;
          });
      }, 300);
    },
  },
};
</script>

<style scoped>
.background-login {
  background-color: white !important;
}
</style>
